import React, { useCallback, useState } from 'react';

import { useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet';

import { Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import useAppNavigation from '~/hooks/useAppNavigation';

import { formatUTCDateDateTimeWidget } from '~/services/TimeService';
import dealPageService from '~/services/cruises/DealPageService';

import DealPageForm from './components/DealPageForm';
import { CruiseDealPageCreation } from './types';

function DealPageCreate() {
  const { enqueueSnackbar } = useSnackbar();
  const { push } = useAppNavigation();
  const [fetching, setFetching] = useState(false);

  const handleSubmit = useCallback(
    async (formValues: CruiseDealPageCreation) => {
      setFetching(true);

      try {
        await dealPageService.create({
          ...formValues,
          startDate: formatUTCDateDateTimeWidget(new Date(formValues.startDate)),
          endDate: formatUTCDateDateTimeWidget(new Date(formValues.endDate)),
        });
        enqueueSnackbar('Deal page created successfully', { variant: 'success' });
        push('/cruises/deals');
      } catch (error) {
        const errorMessage =
          (error as { responseBody?: { message?: string } }).responseBody?.message ??
          (error instanceof Error ? error.message : 'Error saving deal page');
        enqueueSnackbar(errorMessage, { variant: 'error' });
      } finally {
        setFetching(false);
      }
    },
    [enqueueSnackbar, push],
  );

  return (
    <Container>
      <Helmet>
        <title>Create New Deal Page</title>
      </Helmet>

      <PageHeader title="Create Deal Page" backButton="/cruises/deals" />

      <Box mt={1}>
        <DealPageForm onSubmit={handleSubmit} isFetching={fetching} />
      </Box>
    </Container>
  );
}

export default DealPageCreate;
